import { setRandomBytesProvider } from "./prng.js";

export function loadBrowserPrng() {
  // Only install a PRNG if the environment provides a CSPRNG.  Otherwise
  // leave the throwing default in place: this module is compiled into the
  // browser entry point and is also reached where `self` does not exist
  // (SSR, bundler-time evaluation, tests), where a substitute source would
  // silently yield predictable keys.
  const glob = globalThis as any;
  const cr =
    typeof glob.self !== "undefined"
      ? glob.self.crypto || glob.self.msCrypto
      : undefined;

  if (!cr || typeof cr.getRandomValues !== "function") {
    return;
  }

  const QUOTA = 65536;
  setRandomBytesProvider(function (n: number) {
    const v = new Uint8Array(n);
    for (let i = 0; i < n; i += QUOTA) {
      cr.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
    }
    return v;
  });
}
